import { TEXT_CORE_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../../fabrics/createDisplayName";

export const createDisplayNameForTextCoreElement = createDisplayName(
    TEXT_CORE_DISPLAY_NAME,
);
